import type { PhoneNumberValidationBodyProps, ValidationResponse } from './types'
import { getPhoneNumberValidationUrl } from '../../../constants/ccAppServiceUri'
import { ApiCCApp } from '../api/endpoints'

const submitValidatePhoneNumber = async (
  body: PhoneNumberValidationBodyProps
): Promise<boolean> => {
  // For reference:
  // https://cc-applications.internal.gcp.missionlane-staging.com/#tag/Phone-Numbers/operation/phoneNumberValidation
  const phoneNumberValidationUrl = getPhoneNumberValidationUrl()
  try {
    const response = await ApiCCApp.post<PhoneNumberValidationBodyProps, ValidationResponse>(
      phoneNumberValidationUrl,
      body
    )
    const { data } = response
    return data.valid
  } catch {
    return false
  }
}

export default submitValidatePhoneNumber
